import { Box, Button, Heading, Text } from '@zillow/constellation-10';
import type { ReactNode } from 'react';
import { type ListingTenantInfoDto as Tenant } from '@zg-rentals/ts-rins-client';
import TenantSelection from './TenantSelection';

type ModalState = {
  header: ReactNode;
  body: ReactNode;
  footer: ReactNode;
};

type SendRequestProps = {
  tenantsList: Array<Tenant>;
  selectedTenants: Record<string, Tenant>;
  onTenantChange: (tenant: Tenant) => void;
  onSendRequest: () => void;
};

const CONTENT = {
  TITLE: 'Proof of insurance request',
  LABEL: 'Who needs to provide proof of renters insurance?',
  HELP: 'Select all tenants who you want to receive this request. ',
  CTA: 'Send request',
} as const;

export const SendRequest = ({
  tenantsList,
  selectedTenants,
  onTenantChange,
  onSendRequest,
}: SendRequestProps): ModalState => {
  const hasSelection = Object.keys(selectedTenants).length > 0;

  const header = (
    <Heading data-testid="ProofRecomendedActions-Header" level={2} textStyle="heading-xs">
      {CONTENT.TITLE}
    </Heading>
  );

  const body = (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
      <Text textStyle="heading-sm">{CONTENT.LABEL}</Text>
      <Text textStyle="body">{CONTENT.HELP}</Text>
      <TenantSelection
        tenantList={tenantsList}
        selectedTenants={Object.keys(selectedTenants)}
        onChange={onTenantChange}
      />
    </Box>
  );

  const footer = (
    <Button
      data-testid="ProofRecomendedActions-SendRequestButton"
      tone="brand"
      emphasis="filled"
      size="md"
      onClick={onSendRequest}
      disabled={!hasSelection}
    >
      {CONTENT.CTA}
    </Button>
  );

  return { header, body, footer };
};
